import { Box, CloseButton, Flex } from '@chakra-ui/react';
import { ShieldAlert } from 'lucide-react';
import { useT } from '../../i18n';

// A new device on my own account (M73): noticed by this device's record,
// not the server's D94 notice, which a dishonest server could leave out.
// Quiet and local, shown once: tapping it or closing it puts it away.
export function OwnDeviceNotice({
  onOpen,
  onDismiss,
}: {
  /** Opens My devices. */
  onOpen: () => void;
  onDismiss: () => void;
}) {
  const t = useT();
  return (
    <Flex
      data-testid="own-device-notice"
      align="center"
      gap={1}
      mx={3}
      mt={2}
      px={2}
      borderRadius="full"
      bg="surface.subtle"
    >
      <Box
        as="button"
        type="button"
        onClick={onOpen}
        flex="1"
        display="inline-flex"
        alignItems="center"
        gap={2}
        minH="40px"
        px={2}
        fontSize="sm"
        color="ink.body"
        textAlign="left"
        _hover={{ textDecoration: 'underline' }}
        _focusVisible={{ boxShadow: 'outline', outline: 'none' }}
      >
        <ShieldAlert size={16} aria-hidden="true" />
        <span>{t('chat.ownDeviceAdded')}</span>
      </Box>
      <CloseButton
        size="sm"
        aria-label={t('common.close')}
        onClick={onDismiss}
      />
    </Flex>
  );
}
